@if (icon) {
<un-icon
  [type]="icon + '-empty-' + (colorScheme.theme$ | async)"
  theme="custom"
  [size]="size"
></un-icon>
} @if (description) {
<p>{{ description }}</p>
} @if (btnText) {
<un-button [link]="btnLink" size="large" type="primary">{{
  btnText
}}</un-button>
}
